import { useState, useEffect } from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import { resolveDistributor } from '..';

const useDistributor = () => {
	const [distributor, setDistributor] = useState(true);
	const [locationInfo, setLocationInfo] = useState({});

	const { wp } = useStaticQuery(graphql`
		query {
			wp {
				globalSettings {
					acfGlobalSettings {
						distributors {
							country
							countryIso
						}
					}
				}	
			}
		}
	`);

	const wpDistribrutors = wp?.globalSettings?.acfGlobalSettings?.distributors;

	const handleDistributor = async() => {
		await resolveDistributor(
			wpDistribrutors,
			setDistributor,
			setLocationInfo
		);
	};

	useEffect(() => {
		handleDistributor();
	}, []); // eslint-disable-line

	return {
		distributor,
		locationInfo,
		setDistributor,
	};
};

export default useDistributor;
